import request from "../../utils/axios";

export const apiCreateCallLog = async (data) => {
  const res = await request.post({ url: "/member/call-log/create", data });
  return res;
};

export const apiUpdateCallLog = async (data) => {
  const res = await request.put({ url: "/member/call-log/update-by-callid", data });
  return res;
};
